import React from 'react'
import styled from 'styled-components'
import { Popup } from '../../../../components/Popup'
import CrossIcon from '../../../../components/Images/CrossDark'
import { Box } from '../../../../designSystem'

const Heading = styled.h1`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: var(--Text500);
`

const Container = styled.object`
    width: 100%;
    height: 100%;
    & iframe{
        height: 90%;
    }
`


const DataModal = ({ onClose, heading, url}) => {
  return (
    <Popup show close={onClose} className="fullview-modal" >
          <Box variant="flex">
            <Box width={["100%"]}><Heading>{heading}</Heading></Box>
            <Box><CrossIcon onClick={onClose} /></Box>
          </Box>
            <Container data={url} type="application/pdf">
                <iframe title={heading} src={url} frameBorder="0">
                    <p>This browser does not support PDF!</p>
                </iframe>
            </Container>
    </Popup>
  )
}

export default DataModal